module.exports = __webpack_public_path__ + "static/media/logo@2x.eaf578a6.png";